import styled from "@emotion/styled";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 20px 80px 20px;
  gap: 40px;
  min-width: 1140px;
  position: relative;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 20px;
`;

export const FilterSection = styled.div`
  display: flex;
  padding: 0 20px;
  gap: 40px;
`;

export const LocationFilterContainer = styled.div`
  display: flex;
  gap: 12px;
  height: 38px;
  align-items: center;
  white-space: nowrap;
  position: relative;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 20px;
`;

export const CardList = styled.div`
  display: grid;
  height: 708px;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 24px;
  grid-template-rows: max-content;
`;
